import styles from './howItWorks.module.css'

const howItWorksStyle = {
    container: `landing_page_component_wrapper flex flex-col items-center container mx-auto`,
    card_wrpr: `flex flex-wrap justify-center items-center gap-12
                screen-1200:grid-cols-4 screen-1200:justify-between screen-1200:items-start screen-1200:w-full
                sm:grid sm:grid-cols-2 sm:gap-[25px]
    `,
  };
  
const transitionStyle = `transition-all duration-300 ease-in-out
                         group-hover:transition-all group-hover:duration-300 group-hover:ease-in-out
  `

const cardStyle = {
    card_wrpr: `relative overflow-hidden group w-[280px] h-[380px] bg-no-repeat bg-cover bg-center rounded-[20px] border border-lightborderColor
                xl:h-[400px]
                screen-1200:w-[100%]
    `,
    overlay_screen: `absolute inset-0 ${styles.overlayScreen} w-full h-full opacity-0 ${transitionStyle}
                      group-hover:opacity-100
    `,
    overlay_screen_default: `absolute bottom-0 ${styles.overlayScreenDefault} w-full h-1/2 opacity-100 ${transitionStyle}
                              group-hover:opacity-0
    `,
    text_wrpr: `absolute inset-0 flex flex-col items-center justify-center gap-[24px] px-3 ${transitionStyle} translate-y-[40%]
                  group-hover:translate-y-[0]
    `,
    heading: `text-primaryHeading text-[20px] font-[700] font-Suisse uppercase text-center flex items-start leading-[normal]
              group-hover:h-[unset]
              sm:text-[24px] sm:h-[70px]
    `,
    description: `text-[20px] font-[400] leading-[24px] spacing[0.38px] text-theme-text-color text-center hidden ${transitionStyle}
                  group-hover:block
    `
}

export { howItWorksStyle, cardStyle }